module.exports = __webpack_public_path__ + "img/logo-unifael-branca.b2f2ff31.svg";